import { componentSelector } from 'wordpress/selectors'
import Button from '@components/Button'

import '../styles/Partners.scss'

const partnersConfigurationSelector = componentSelector('partners')

export const Partner = ({ partners }) => {
    const getLink = () =>
        partners.buttonAction === 'page'
            ? {
                  href: partners.page,
              }
            : {
                  href: partners.url,
                  external: true,
              }


    return (
        <div className="partners container-fluid">
            <div className="inner-container">
                <Image className="img-container" image={partners.image} background />
                <div className="info-container">
                    <h1>{partners.title}</h1>
                    <div className="divider">
                        <hr />
                    </div>
                    <div className="text text-large">{partners.content}</div>
                    <Button btnStyle="outline-invert" className="font-weight-bold" inline {...getLink()}>
                        {partners.buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export const Partners = partners => (partners.enabled ? <Partner partners={partners} /> : null)

export default connect(partnersConfigurationSelector)(Partners)
